export const EVENTS = {
    sessionStart: 'session_start',
    onboardingStarted: 'OnboardingStarted',
    onboardingStartedSubmitted: 'OnboardingStartedSubmitted',
    onboardingQuestionPageSubmitted: 'question_page_completed',
    onboardingFactPageSubmitted: 'fact_page_completed',  
    onboardingMassmediaShown: 'OnboardingMassmediaShown',
    onboardingMassmediaSubmitted: 'OnboardingMassmediaSubmitted',
    onboardingRoleShown: "OnboardingRoleShown",
    onboardingRoleSubmitted: "OnboardingRoleSubmitted",
    onboardingRoleSkip: "OnboardingRoleSkip",
    onboardingLocationsShown: "OnboardingLocationsShown",
    onboardingLocationsSubmitted: "OnboardingLocationsSubmitted",
    onboardingLocationsSkip: "OnboardingLocationsSkip",
    onboardingReasonShown: "OnboardingReasonShown",
    onboardingReasonSubmitted: "OnboardingReasonSubmitted",
    onboardingReasonSkip: "OnboardingReasonSkip",
    onboardingCheckTimeShown: "OnboardingCheckTimeShown",
    onboardingCheckTimeSubmitted: "OnboardingCheckTimeSubmitted",
    onboardingCheckTimeSkip: "OnboardingCheckTimeSkip",
    onboardingUpdatesShown: "OnboardingUpdatesShown",
    onboardingUpdatesSubmitted: "OnboardingUpdatesSubmitted",
    onboardingUpdatesSkip: "OnboardingUpdatesSkip",
    onboardingInappropriateShown: "OnboardingInappropriateShown",
    onboardingInappropriateSubmitted: "OnboardingInappropriateSubmitted",
    onboardingInappropriateSkip: "OnboardingInappropriateSkip",
    onboardingQuantityShown: "OnboardingQuantityShown",
    onboardingQuantitySubmitted: "OnboardingQuantitySubmitted",
    onboardingQuantitySkip: "OnboardingQuantitySkip",
    onboardingFeatureListShown: "OnboardingFeatureListShown",
    onboardingFeatureListSubmitted: "OnboardingFeatureListSubmitted",
    onboardingFeatureListSkip: "OnboardingFeatureListSkip",
    OnboardingReceivedAnswersShown: "OnboardingReceivedAnswersShown",
    onboardingReceivedAnswersSubmitted: "OnboardingReceivedAnswersSubmitted",
    onboardingRealTimeLocation: 'OnboardingRealTimeLocation',
    onboardingRealTimeLocationSubmitted: 'OnboardingRealTimeLocationSubmitted',
    onboardingPlaceAlerts: 'OnboardingPlaceAlerts',
    onboardingPlaceAlertsSubmitted: 'OnboardingPlaceAlertsSubmitted',
    onboardingCheckIn: 'OnboardingCheckIn',
    onboardingCheckInSubmitted: 'OnboardingCheckInSubmitted',
    onboardingLocationHistory: 'OnboardingLocationHistory',
    onboardingLocationHistorySubmitted: 'OnboardingLocationHistorySubmitted',
    onboardingSos: 'OnboardingSos',
    onboardingSosSubmitted: 'OnboardingSosSubmitted',
    onboardingPlatformsShown: "OnboardingPlatformsShown",
    onboardingPlatformsSubmitted: "OnboardingPlatformsSubmitted",
    onboardingEnterEmailShown: 'OnboardingEnterEmailShown',
    onboardingEnterEmailSubmitted: 'OnboardingEnterEmailSubmitted',
    signupSuccess: 'AccountCreated',
    onboardingCreatingProfile: 'OnboardingCreatingProfile',
    onboardingCreatingProfileSubmitted: 'OnboardingCreatingProfileSubmitted',
    onboardingPaywallShown: 'OnboardingPaywallShown',
    onboardingPaywallChosen: 'OnboardingPaywallChosen',
    onboardingCheckoutShown: 'OnboardingCheckoutShown',
    cardMethodChosen: 'CardCheckoutChosen',
    googlePlayTapped: 'GooglePlayTapped',
    appleStoreTapped: 'AppleStoreTapped',
    subBuyTapped: 'SubBuyTapped',
    subscribed: 'PaywallSubscribed',
    subBuyClosed: 'PaywallClosed',
    paymentAnimationScreen: 'PaymentAnimationScreen',
    onboardingPaymentDecline: 'OnboardingPaymentDecline',
    onboardingDeclineTryAgain: 'OnboardingDeclineTryAgain',
    upsellView: 'UpsellView',
    upsellTapped: 'UpsellTapped',
    upsellTappedClose: 'UpsellCloseTapped',
    upsellPurchased: 'UpsellPurchased',
    upsellFailed: 'UpsellPurchasedFailed',
    onboardingSuccessShown: 'OnboardingSuccessShown',
    onboardingDone: 'OnboardingDone',
};